import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

const mainLines = [
  {
    id: 'cex',
    icon: 'ri-exchange-dollar-line',
    labelKey: 'productsOverview.lines.cex.label',
    color: '#FF2D78',
    path: '/products/cex',
    image: 'http://geel.fp.08wx.cn/images/935ecd59d62e80e6f6000b7884947eb9.jpg',
    descKey: 'productsOverview.lines.cex.desc',
    tags: ['productsOverview.lines.cex.tags.0', 'productsOverview.lines.cex.tags.1', 'productsOverview.lines.cex.tags.2', 'productsOverview.lines.cex.tags.3'],
    stats: [{ val: '100K+', labelKey: 'productsOverview.lines.cex.stats.0' }, { val: '99.99%', labelKey: 'productsOverview.lines.cex.stats.1' }],
  },
  {
    id: 'wallet',
    icon: 'ri-wallet-3-line',
    labelKey: 'productsOverview.lines.wallet.label',
    color: '#FF2D78',
    path: '/products/wallet',
    image: 'http://geel.fp.08wx.cn/images/9556b54d51318cfbe6b856b57dc73627.jpg',
    descKey: 'productsOverview.lines.wallet.desc',
    tags: ['productsOverview.lines.wallet.tags.0', 'productsOverview.lines.wallet.tags.1', 'productsOverview.lines.wallet.tags.2'],
    stats: [{ val: '80+', labelKey: 'productsOverview.lines.wallet.stats.0' }, { val: '3', labelKey: 'productsOverview.lines.wallet.stats.1' }],
  },
  {
    id: 'rwa',
    icon: 'ri-building-2-line',
    labelKey: 'productsOverview.lines.rwa.label',
    color: '#FF2D78',
    path: '/products/rwa',
    image: 'http://geel.fp.08wx.cn/images/0f6ab0f65554b793795bd38b4705c50b.jpg',
    descKey: 'productsOverview.lines.rwa.desc',
    tags: ['productsOverview.lines.rwa.tags.0', 'productsOverview.lines.rwa.tags.1', 'productsOverview.lines.rwa.tags.2', 'productsOverview.lines.rwa.tags.3'],
    stats: [{ val: '3', labelKey: 'productsOverview.lines.rwa.stats.0' }, { val: 'Global', labelKey: 'productsOverview.lines.rwa.stats.1' }],
  },
  {
    id: 'dapp',
    icon: 'ri-apps-2-line',
    labelKey: 'productsOverview.lines.dapp.label',
    color: '#FF2D78',
    path: '/products/defi',
    image: 'http://geel.fp.08wx.cn/images/52f879c53f46d7d0f28f6ac19aa1345d.jpg',
    descKey: 'productsOverview.lines.dapp.desc',
    tags: ['productsOverview.lines.dapp.tags.0', 'productsOverview.lines.dapp.tags.1', 'productsOverview.lines.dapp.tags.2', 'productsOverview.lines.dapp.tags.3'],
    stats: [{ val: 'Source', labelKey: 'productsOverview.lines.dapp.stats.0' }, { val: 'All-chain', labelKey: 'productsOverview.lines.dapp.stats.1' }],
  },
];

export default function ProductsOverviewSection() {
  const { t } = useTranslation();

  return (
    <section className="bg-white py-24">
      <div className="max-w-[1400px] mx-auto px-6">
        {/* Section Header */}
        <div className="text-center mb-16">
          <div className="inline-flex items-center gap-2 mb-4 px-3 py-1.5 bg-primary/10 border border-primary/20 rounded-full">
            <span className="w-2 h-2 rounded-full bg-primary animate-pulse" />
            <span className="text-primary text-xs font-medium uppercase tracking-widest">{t('productsOverview.tag')}</span>
          </div>
          <h2 className="text-4xl md:text-5xl font-heading font-bold text-gray-900 mb-4">
            {t('productsOverview.title')}
          </h2>
          <p className="text-gray-500 text-base max-w-2xl mx-auto">
            {t('productsOverview.desc1')}
            {t('productsOverview.desc2')}
          </p>
        </div>

        {/* Main product cards - 2 col grid */}
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
          {mainLines.map((item, i) => (
            <Link
              key={i}
              to={item.path}
              className="group bg-white border border-primary/15 hover:border-primary/35 rounded-2xl overflow-hidden transition-all duration-300 cursor-pointer block"
            >
              {/* Image */}
              <div className="relative w-full h-[220px] overflow-hidden">
                <img
                  src={item.image}
                  alt={t(item.labelKey)}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-white via-white/10 to-transparent" />
                <div className="absolute top-4 left-4 flex items-center gap-2 px-3 py-1.5 bg-white/90 border border-primary/20 rounded-lg backdrop-blur-sm">
                  <div className="w-5 h-5 flex items-center justify-center">
                    <i className={`${item.icon} text-sm`} style={{ color: item.color }} />
                  </div>
                  <span className="text-gray-800 text-xs font-medium">{t(item.labelKey)}</span>
                </div>
                {/* Stats pills */}
                <div className="absolute bottom-4 right-4 flex gap-2">
                  {item.stats.map((s, j) => (
                    <div key={j} className="px-2.5 py-1 bg-white/90 border border-primary/20 rounded-lg text-xs backdrop-blur-sm">
                      <span className="font-bold text-primary">{s.val}</span>
                      <span className="text-gray-500 ml-1">{t(s.labelKey)}</span>
                    </div>
                  ))}
                </div>
              </div>

              {/* Content */}
              <div className="p-6">
                <p className="text-gray-500 text-sm leading-relaxed mb-4">{t(item.descKey)}</p>
                <div className="flex flex-wrap gap-2 mb-5">
                  {item.tags.map((tag, j) => (
                    <span key={j} className="px-2.5 py-1 bg-pink-50 border border-primary/15 text-xs text-gray-500 rounded-md">{t(tag)}</span>
                  ))}
                </div>
                <div className="flex items-center gap-2 text-sm font-medium group-hover:gap-3 transition-all duration-200 text-primary">
                  {t('productsOverview.cta')}
                  <div className="w-4 h-4 flex items-center justify-center">
                    <i className="ri-arrow-right-line" />
                  </div>
                </div>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}
